import { createResourceCollection } from '@/request'
import { ThermostatCostHistorySummary } from '@/types/thermostatCostHistorySummary'
import { addThermostatIdFromPath } from './collectionMiddleware'

export const thermostatCostHistorySummaryCollection =
  createResourceCollection<ThermostatCostHistorySummary>({
    name: 'thermostatCostHistorySummaryCollection',
    selector: (state) => state.thermostatCostHistorySummaryCollection,
    apiConfig: {
      middlewares: [addThermostatIdFromPath<ThermostatCostHistorySummary>()],
    },
    computedId: (resource) => resource.thermostat_id,
  })

export default thermostatCostHistorySummaryCollection.slice.reducer
